import { Colors, Styles } from "../preset.constants";

export const menubarPreset = {
    background: Colors.MenubarBackground,
    color: Colors.Primary,
    base: {
        item: {
            border: {
                radius: Styles.BorderRadius
            }
        }
    },
    border: {
        color: Colors.MenubarBackground,
        radius: Styles.BorderRadius
    },
    item: {
        color: Colors.Primary,
        active: {
            color: Colors.PrimaryBackground,
            background: Colors.Primary
        },
        focus: {
            color: Colors.PrimaryBackground,
            background: Colors.Primary
        },
        border: {
            radius: Styles.BorderRadius
        }
    }
}